import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { DsButtonModule, DsMessageModule, DsSwitchModule, SelectListOption } from '@bmw-ds/components';

import { AddressField } from '../../../customer/model/address-field.model';
import { CustomerAddress } from '../../../customer/model/customer-information.model';
import { RegionalAddressComponent } from '../../../form/components/regional-address/regional-address.component';
import { useI18n } from '../../../i18n/services/i18n.service';

@Component({
  selector: 'cdf-form-advanced-search',
  imports: [RegionalAddressComponent, DsButtonModule, DsMessageModule, DsSwitchModule],
  host: { class: 'd-flex flex-wrap gap-2x' },
  template: `
    <div class="buttons">
      <ds-switch [(ngModel)]="isAdvancedSearchExpanded">{{ i18n('advancedSearch') }}</ds-switch>
    </div>

    @if (isAdvancedSearchExpanded()) {
      @if (!isAMainDataFieldFilled()) {
        <ds-message
          class="w-100"
          tone="caution"
          [messageText]="i18n('customerSearch.atLeastOneMainDataFieldMustBeFilled')"
        />
      }
      <cdf-regional-address
        class="w-100"
        [(address)]="address"
        [availableCountries]="availableCountries()"
        [addressUiFormat]="addressUiFormat()"
        [displayClearAddressButton]="false"
      />
    }
    <div class="buttons justify-content-end">
      <ng-content />
    </div>
  `,
  styleUrl: './form-search-for-customer-advanced.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormSearchForCustomerAdvancedComponent {
  protected readonly i18n = useI18n();

  readonly addressUiFormat = input.required<AddressField[][]>();
  readonly isAdvancedSearchExpanded = model.required<boolean>();
  readonly isAMainDataFieldFilled = input.required<boolean>();

  readonly address = model.required<CustomerAddress>();
  readonly availableCountries = input.required<SelectListOption[]>();

  readonly anyFieldInputIsInvalid = input<boolean>();
}
